import http from './http';

export default {
  all() {
    return http().get(`/v1/integration_phone_numbers`);
  },
  update(data, validationErrors) {
    return http(validationErrors).put(`/v1/integration_phone_numbers/${data.id}`, data);
  },
  callContact(contactId, payload, validationErrors) {
    return http(validationErrors).post(`/v1/integration_phone_numbers/call/${contactId}`, payload);
  },
  textContact(contactId, data, validationErrors) {
    return http(validationErrors).post(`/v1/integration_phone_numbers/text/${contactId}`, data);
  },
  scheduledTextContact(contactId, data, validationErrors) {
    return http(validationErrors).post(`/v1/integration_phone_numbers/scheduled-text/${contactId}`, data);
  },
}
